import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import apiService from '../../services/api';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowLeft, FiBookOpen } = FiIcons;

const RecommendationDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [recommendation, setRecommendation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRecommendation = async () => {
      try {
        setLoading(true);
        const response = await apiService.getRecommendationById(id);
        if (response && response.data) {
          setRecommendation(response.data);
        } else {
          setError('Empfehlung nicht gefunden');
        }
      } catch (err) {
        console.error('Error fetching recommendation:', err);
        setError('Fehler beim Laden der Empfehlung');
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchRecommendation();
    }
  }, [id]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[50vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-primary"></div>
      </div>
    );
  }

  if (error || !recommendation) {
    return (
      <div className="p-6 text-center">
        <p className="text-red-500 mb-4">{error || 'Empfehlung nicht gefunden'}</p>
        <button
          onClick={() => navigate('/handbook')}
          className="px-4 py-2 bg-brand-primary text-white rounded-lg hover:bg-brand-dark transition-colors"
        >
          Zurück zum Handbuch
        </button>
      </div>
    );
  }

  // Removed w-[80%] mx-auto as it's now handled by AppLayout
  return (
    <div className="p-6 w-full"> 
      <button
        onClick={() => navigate('/handbook')}
        className="flex items-center text-gray-600 hover:text-brand-primary mb-6 transition-colors group"
      >
        <SafeIcon icon={FiArrowLeft} className="mr-2 w-5 h-5 group-hover:-translate-x-1 transition-transform" />
        Zurück zum Handbuch
      </button>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
        <div className="p-8 border-b border-gray-100 bg-gray-50/50">
          <div className="flex items-center gap-3 text-brand-secondary mb-3">
            <SafeIcon icon={FiBookOpen} className="w-5 h-5" />
            <span className="text-sm font-bold uppercase tracking-wider">Handlungsempfehlung</span>
          </div>
          <h1 className="text-3xl font-bold text-brand-dark">{recommendation.title}</h1>
          {recommendation.short_description && (
            <p className="mt-4 text-lg text-gray-600 leading-relaxed">
              {recommendation.short_description}
            </p>
          )}
        </div>

        <div className="p-8">
          <div 
            className="prose prose-lg max-w-none text-gray-700 [&>h2]:text-xl [&>h2]:font-bold [&>h2]:mt-8 [&>h2]:mb-4 [&>ul]:list-disc [&>ul]:pl-6 [&>ol]:list-decimal [&>ol]:pl-6 [&>li]:mb-2"
            dangerouslySetInnerHTML={{ __html: recommendation.description }}
          />
        </div>
      </div>
    </div>
  );
};

export default RecommendationDetail;